import { z } from "zod";

export const ethnicitySchema = z.object({
  id: z.number(),
  description: z.string(),
  level: z.number(),
});

export type Ethnicity = z.infer<typeof ethnicitySchema>;

export const ethnicitiesSchema = z.array(ethnicitySchema);

export type Ethnicities = z.infer<typeof ethnicitiesSchema>;
